import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:my-24 mt-5 grid gap-y-5 p-2" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "bg-white rounded-lg border border-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_ThemeInfo = _resolveComponent("ThemeInfo")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("theme.admin.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Table, {
        slotData: _ctx.themes,
        columns: _ctx.columns,
        loading: _ctx.loading,
        filters: _ctx.filters,
        hasStatus: true,
        params: _ctx.params,
        customActions: "",
        onOnFilter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterFor())),
        onOnClearFilter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilter())),
        onOnToggleFilter: _cache[3] || (_cache[3] = (e, type) => _ctx.toggleFilter(e, 'name')),
        onOnPaginate: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paginate($event)))
      }, {
        filters: _withCtx(() => [
          (_ctx.filterType === 'name')
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                modelValue: _ctx.filters.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.name) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        actions: _withCtx(({ columnProps }) => [
          _createVNode(_component_Button, {
            icon: "pi pi-eye",
            class: "btn-simple",
            onClick: _withModifiers(($event: any) => (_ctx.openItem(columnProps.data)), ["prevent"])
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["slotData", "columns", "loading", "filters", "params"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.openDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.openDialog) = $event)),
      header: _ctx.$t('theme.admin.dialog.title') + _ctx.theme?.organization?.name + ' - ' + _ctx.theme?.subdomain,
      draggable: false,
      style: { width: '80vw', maxWidth: '1080px' },
      modal: ""
    }, {
      default: _withCtx(() => [
        (_ctx.openDialog)
          ? (_openBlock(), _createBlock(_component_ThemeInfo, {
              key: 0,
              "org-id": _ctx.theme?.organization?.id,
              domain: _ctx.theme.subdomain
            }, null, 8, ["org-id", "domain"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}